import React, { useEffect, useCallback } from 'react';

import { sections } from '../../../common/config';
import useAnimationStore from '../../../common/store/useAnimationStore';

const useAnimation = (ref: React.RefObject<HTMLDivElement>) => {
  const page = useAnimationStore(useCallback(state => state.landing.page, []));

  useEffect(() => {
    page.to(ref.current, {
      duration: 2.8,
      ease: "power2.inOut",
      y: `-${sections.height.landing}vh`
    });

    return () => { page.clear() }
  }, []);
}

export default useAnimation;